import React from "react"
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"

interface DeleteImageDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
}

const DeleteImageDialog: React.FC<DeleteImageDialogProps> = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Remove image?</DialogTitle>
      <DialogContent>
        <DialogContentText>Are you sure you want to delete this image from the selection?</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>No</Button>
        <Button color="error" onClick={onConfirm}>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteImageDialog
